import { connect } from "react-redux";
import Search from "../../../components/features/search/Search";

export default connect((_) => ({}), {})(Search);
